import React from 'react'
import {Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {toast} from 'react-toastify'

import {IdentificationBadgeIcon} from '../../../icons/IdentificationBadgeIcon'
import {ToastMessage} from '../../Toast'

import {useRails} from '../../../contexts/rails'
import {requestVerification} from '../../../../api'

export const stepName = 'idVerification'

const calculateStatus = ({verificationStatus}) => {
  if (verificationStatus === 'verified') {
    return 'completed'
  }
  if (verificationStatus === 'pending') {
    return 'reviewing'
  }

  return 'incomplete'
}

export default (stepperData) => {
  const {t} = useTranslation('cashinStepper')
  const {
    organisation: {
      currentSupplier: {id: supplierId},
    },
    authenticityToken,
  } = useRails()
  const {canVerifyIdentity, verificationStatus} = stepperData
  const [requested, setRequested] = React.useState(false)

  const handleVerifyClick = () => {
    setRequested(true)

    requestVerification({authenticityToken, supplierId})
      .then(() => {
        toast.dark(
          <ToastMessage>
            FirstAML has sent you an email to start the KYC process.
          </ToastMessage>,
        )
      })
      .catch(() => {
        setRequested(false)
        toast.error(
          <ToastMessage>
            Something went wrong. Please try again or contact support.
          </ToastMessage>,
        )
      })
  }

  const effectiveStatus =
    verificationStatus !== 'verified' && requested
      ? 'pending'
      : verificationStatus
  const status = calculateStatus({verificationStatus: effectiveStatus})

  return {
    name: stepName,
    visible: true,
    status,
    active: status === 'incomplete' && canVerifyIdentity,
    icon: <IdentificationBadgeIcon />,
    title: t('steps.idVerification.title'),
    subtitle: {default: t('steps.idVerification.subtitle')},
    notification:
      status === 'incomplete' && !canVerifyIdentity ? (
        <Text textStyle="body-small" color="mld.neutral.700">
          {t('steps.idVerification.notAvailable')}
        </Text>
      ) : undefined,
    action: {
      label: t('steps.idVerification.actionLabel'),
      onClick: handleVerifyClick,
    },
  }
}
